import React from 'react';
import { notNeeded, repeatSteps } from '../data/salesPage';
export function LastThingSection() {
  return <section aria-labelledby="ultima-cosa" className="bg-ink" data-id="element-114" data-mp="2kcuizzwx20ke">
      <div className="mx-auto max-w-3xl px-5 py-20 sm:py-28" data-id="element-115" data-mp="25nok6d1zqcd1">
        <h2 id="ultima-cosa" className="font-display text-sm font-bold uppercase tracking-[0.25em] text-lime" data-id="element-116" data-mp="25n5afjmhuua3">Una última cosa</h2>
        <ul className="mt-8 space-y-2" data-id="element-117" data-mp="2akf112lmdbzi">
          {notNeeded.map(line => <li key={line} className="font-display text-2xl font-bold text-bone-muted sm:text-3xl" data-id="element-118" data-mp="1wlp3jluw1aam">{line}</li>)}
        </ul>
        <p className="mt-8 font-display text-4xl font-black uppercase text-bone sm:text-5xl" data-id="element-119" data-mp="1mp2iox2kaj8l">Necesitás empezar.</p>

        <p className="mt-12 text-lg text-bone-muted" data-id="element-120" data-mp="1rn3ztcgfg8hf">Después:</p>
        <ol className="mt-4 flex flex-wrap gap-x-6 gap-y-2" data-id="element-121" data-mp="1rpqgq2p7k0cb">
          {repeatSteps.map(step => <li key={step} className="font-display text-2xl font-extrabold text-bone" data-id="element-122" data-mp="3m1y7d3uhxv2a">{step}</li>)}
        </ol>
        <p className="mt-6 font-display text-2xl font-extrabold text-lime" data-id="element-123" data-mp="17m178d6kwdzg">Y repetir.</p>

        <p className="mt-20 text-center font-display text-4xl font-black uppercase leading-tight text-bone sm:text-6xl" data-id="element-124" data-mp="12nravz94b7c9">
          Nos vemos en el <span className="text-lime" data-id="element-125" data-mp="1hb2o05ky6zeh">día 1.</span>
        </p>
      </div>

      <footer className="border-t border-ink-line" data-id="element-126" data-mp="1ccrg40e7qyyw">
        <div className="mx-auto flex max-w-5xl flex-col items-center gap-2 px-5 py-10 text-center" data-id="element-127" data-mp="1cfdvgm7ciiro">
          <p className="font-display text-lg font-black uppercase text-bone" data-id="element-128" data-mp="opt1775qrz33">Cómo perder grasa en 45 días</p>
          <p className="text-sm text-bone-dim" data-id="element-129" data-mp="jqykqbv8ymm5">Tu proceso empieza ahora.</p>
        </div>
      </footer>
    </section>;
}